import { AfterContentChecked, Component, Inject, OnDestroy, OnInit, Optional, Self } from '@angular/core';
import { FormBuilder, NgControl, Validators } from '@angular/forms';
import { IAngularMyDpOptions } from '@nodro7/angular-mydatepicker';
import { Subscription } from 'rxjs';
import { APP_CONFIG } from '../../../app.config';
import { AssistantPopoverService } from '../../../common/assistant-popover.service';
import { DATEPICKER_CONFIG } from '../../../common/datepicker-config';
import { LichtbildService } from '../../../common/lichtbild.service';
import { ValidationService } from '../../../common/validation.service';
import { ValueListsService } from '../../../common/value-lists.service';
import { AppConfig } from '../../../models/config/app-config';
import { ValueListItem } from '../../../models/rest/valuelist/valuelist';
import { VisumErfassungSubFormComponent } from '../visum-erfassung-sub-form/visum-erfassung-sub-form.component';

@Component({
  selector: 'app-lichtbild',
  templateUrl: './lichtbild.component.html',
  styleUrls: ['./lichtbild.component.scss']
})
export class LichtbildComponent extends VisumErfassungSubFormComponent implements OnInit, AfterContentChecked, OnDestroy {

  private erfassungListItemsSub: Subscription;
  erfassungListItems: ValueListItem[] = [];


  constructor(fb: FormBuilder,
              private valueListsService: ValueListsService,
              private validationService: ValidationService,
              private lichtbildService: LichtbildService,
              assistantPopoverService: AssistantPopoverService,
              @Inject(DATEPICKER_CONFIG) public datepickerOptions: IAngularMyDpOptions,
              @Optional() @Self() controlDir: NgControl,
              @Inject(APP_CONFIG) public appConfig: AppConfig) {
    super(controlDir, assistantPopoverService);

    this.form = this.wrapFormGroup(fb.group({
      scannertyp: [null, []],
      lichtbild: [null, [Validators.required]],
      wasCapturingSuccessful: null
    }));
  }

  ngOnInit() {
    super.ngOnInit();

    this.erfassungListItemsSub = this.lichtbildService.getLichtbildDevices()
    .subscribe((listItems: ValueListItem[]) => {
      this.erfassungListItems = listItems;
    });

  }

  ngAfterContentChecked(): void {
    // Wird nach jeder Model-Änderung aber noch vor Initialisierung/Aktualisierung der View aufgerufen
    // (siehe https://angular.io/guide/lifecycle-hooks). Die Wertelisten sind zu diesem Zeitpunkt bereits
    // geladen und die Select-Options gefüllt und damit für eine initiale Vorbelegung verfügbar.
    if (!this.form.value.scannertyp) {
      const initialDevice = this.lichtbildService.findInitialDevice();
      if (initialDevice) {
        this.form.controls['scannertyp'].setValue(initialDevice);
      }
    }
  }

  ngOnDestroy(): void {
    this.erfassungListItemsSub.unsubscribe();
  }

  captureLichtbild() {
    const form = this.form;
    this.lichtbildService.captureLichtbild(form.value.scannertyp)
    .subscribe({
      next: (blob) => {
        const fileReader = new FileReader();
        fileReader.onload = (_event) => {
          form.patchValue({ lichtbild: btoa(fileReader.result as string), wasCapturingSuccessful: true });
          // Da man ggf. kein sichtbares Formularelement ändert, um ein Bild zu erfassen (wenn man das
          // vorausgewählte Erfassungsgerät verwendet), braucht man dieses markAsTouched(), damit das Subformular
          // für den Statusbalken auch "grün" bedeutet.
          form.controls['lichtbild'].markAsTouched();
          form.controls['lichtbild'].updateValueAndValidity();
          form.controls['wasCapturingSuccessful'].markAsTouched();
          form.controls['wasCapturingSuccessful'].updateValueAndValidity();
        };
        fileReader.readAsBinaryString(blob);
      },
      error: () => {
        form.patchValue({ lichtbild: null, wasCapturingSuccessful: false });
      }
    });
  }

  changeDevice(): void {
    this.lichtbildService.changeLastUsedDevice(this.form.value.scannertyp);
  }
}
